export default __webpack_public_path__ + "static/media/schedule.a04e970b.png";